export default __webpack_public_path__ + "static/media/qrStep1Icon.15d88f23.png";